import PropTypes from 'prop-types';

export const specie = PropTypes.shape({
  key: PropTypes.number,
  label: PropTypes.shape({
    es: PropTypes.string,
    gl: PropTypes.string
  }),
  xorfor_id: PropTypes.number,
});